<template>
  <div id="app">
    <img
      class="download-link"
      @click="handleClick"
      src="https://qiniufile.mddcloud.com.cn/static/download/download-tip_vi.png?v=1"
    />
  </div>
</template>

<script>
import { uploadLogs } from "@/common/mddH5/1.0.0/tool/uploadLogs.js";
import { isIos } from "@/common/mddH5/1.0.0/tool/assert.js";
export default {
  name: "App",
  data() {
    return {
      channel: "download",
      openType: "",
      dataUid: "",
      jumpType: "",
      ios_link: null,
      adr_link: null,
    };
  },
  mounted() {
    this.channel = getParam("channel") || "mdd"; // 一定要带渠道号才可以区分下载链接
    this.openType = getParam("openType") || "";
    this.dataUid = getParam("dataUid");
    this.jumpType = getParam("jumpType");

    this.ios_link = sessionStorage.getItem("ios_link");
    this.adr_link = sessionStorage.getItem("adr_link");

    this.trace({ action: "download_show" });
  },
  methods: {
    trace({ action, label = -1, value = -1 }, isDelay = false) {
      var label =
        action === "download_click"
          ? this.openType == 2
            ? `-1,2,-1,-1`
            : `-1,1,${this.jumpType},${this.dataUid}`
          : "-1";
      return uploadLogs(
        {
          game_id: 9,
          page: "download_page",
          channel: this.channel ? this.channel : "-1",
          action,
          label,
          value,
        },
        {},
        isDelay
      );
    },
    handleClick() {
      this.trace({ action: "download_click" }).then(() => {
        console.log("点击下载");
        this.handleDownload();
      });
    },
    handleDownload() {
      const ua = navigator.userAgent.toLowerCase();
      if (
        ua.toLowerCase().match(/MicroMessenger/i) == "micromessenger" ||
        ua.match(/QQ\//i) == "QQ/" ||
        ua.toLowerCase().match(/WeiBo/i) == "weibo"
      ) {
        document.querySelector(".mask").style.display = "block";
      } else {
        if (this.openType == 2) {
          console.log(sensors, "sensors");
          window.SensorsSLink.openApp();
        } else {
          this.defaultOpenApp();
          const link = isIos ? this.ios_link : this.adr_link;
          function timedCount() {
            if (!link) {
              alert("链接失效");
            } else {
              window.location.href = link;
            }
          }
          setTimeout(timedCount, 500);
        }
      }
    },
    defaultOpenApp() {
      var openUrl = "mdd://view/jump";
      var jumpType = this.jumpType;
      var dataUid = this.dataUid;
      var channel = this.channel; // 一定要带渠道号才可以区分下载链接

      try {
        // 5720需求，兼容app分享出去的链接
        var code = getParam("code");
        var postUuid = getParam("postUuid"); // 帖子uuid
        var autoPlay = getParam("autoPlay"); // 短视频UUID
        const routerPrefix = "mdd://com.tvbc.maiduidui";
        if (code === "0" && (postUuid || autoPlay)) {
          let router = "/main/tab?tabName=home"; // code==0, 无其他参数则跳转主页
          if (postUuid) {
            router = "/post/detail?postUuid=" + postUuid;
          } else if (autoPlay) {
            router = "/autoPlay?type=1&uuid=" + autoPlay;
          }
          const url = routerPrefix + router;
          console.log("url", url);
          window.location.href = url;
        }

        if (jumpType == 0) {
          jumpType = 1;
        } else if (jumpType == 1) {
          jumpType = 8;
        } else if (jumpType == 2) {
          jumpType = 13;
        } else if (jumpType == 3) {
          jumpType = 10;
        } else if (jumpType == 4) {
          jumpType = 11;
        }
        console.log("jumpType", jumpType);
        window.location.href =
          openUrl +
          "?jumpType=" +
          jumpType +
          "&dataUid=" +
          dataUid +
          "&channel=" +
          channel;
      } catch (err) {
        txt = "本页有一个错误。\n\n";
        txt += "错误描述：" + err.message + "\n\n";
        txt += "点击确定继续。\n\n";
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
